var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.132,
    height: 28.927,
    viewBox: "0 0 25.132 28.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-tiktok",
    "data-name": "Icon simple-tiktok",
    d: "M15.568.024C17.147,0,18.714.012,20.281,0A7.507,7.507,0,0,0,22.39,5.026,8.5,8.5,0,0,0,27.5,7.184v4.857a12.9,12.9,0,0,1-5.062-1.169,14.892,14.892,0,0,1-1.953-1.121c-.012,3.519.012,7.039-.024,10.546a9.206,9.206,0,0,1-1.627,4.749,8.98,8.98,0,0,1-7.123,3.869,8.789,8.789,0,0,1-4.918-1.241,9.089,9.089,0,0,1-4.4-6.882c-.024-.6-.036-1.205-.012-1.8A9.074,9.074,0,0,1,12.9,10.944c.024,1.784-.048,3.568-.048,5.351a4.136,4.136,0,0,0-5.279,2.555,4.781,4.781,0,0,0-.169,1.941,4.1,4.1,0,0,0,4.219,3.459,4.049,4.049,0,0,0,3.339-1.941,2.781,2.781,0,0,0,.494-1.278c.121-2.157.072-4.3.084-6.46.012-4.857-.012-9.7.024-14.548Z",
    transform: "translate(-2.369)",
    fill: "#2eafbe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTiktok);
export default __webpack_public_path__ + "static/media/icon-tiktok.0eb926e6638888d50436622b97e79628.svg";
export { ForwardRef as ReactComponent };